import styled from 'styled-components/macro';

// import theme helpers
import { getBreakpoint, getColor } from '../../../util/theme';

const ReviewItemContent = styled.div`
  background-color: ${getColor('primaryBlue')};

  position: absolute;
  top: 10px;
  left: 10px;

  height: calc(100% - 20px);
  width: calc(100% - 20px);

  clip-path: polygon(
    0% 10%,
    15% 10%,
    15% 0%,
    100% 0,
    100% 95%,
    90% 95%,
    90% 100%,
    80% 95%,
    0 95%
  );

  padding: 35px 20px;

  a,
  p {
    color: ${getColor('white')};

    padding: 10px 0 0 10px;
  }

  a {
    font-size: 1.8rem;

    &:hover {
      color: ${getColor('accentGreen')};
    }
  }

  .quote-right {
    position: absolute;
    bottom: 50px;
    right: 15px;

    @media (min-width: ${getBreakpoint('sm')}) {
      bottom: 35px;
    }

    @media (min-width: ${getBreakpoint('lg')}) {
      bottom: 50px;
    }

    @media (min-width: ${getBreakpoint('xl')}) {
      bottom: 75px;
    }
  }
`;

export default ReviewItemContent;
